var _rect, _rect2, _rect3, _g, _rect4, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplateTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 80,
    height: 66,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 80,
    height: 66,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_121)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 16,
    width: 80,
    height: 66,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.426 61V58.4545L140.301 50.2955C141.142 49.4091 141.835 48.6326 142.381 47.9659C142.934 47.2917 143.347 46.6515 143.619 46.0455C143.892 45.4394 144.028 44.7955 144.028 44.1136C144.028 43.3409 143.847 42.6742 143.483 42.1136C143.119 41.5455 142.623 41.1098 141.994 40.8068C141.366 40.4962 140.657 40.3409 139.869 40.3409C139.036 40.3409 138.309 40.5114 137.688 40.8523C137.066 41.1932 136.589 41.6742 136.256 42.2955C135.922 42.9167 135.756 43.6439 135.756 44.4773H132.403C132.403 43.0606 132.729 41.822 133.381 40.7614C134.032 39.7008 134.926 38.8788 136.062 38.2955C137.199 37.7045 138.491 37.4091 139.938 37.4091C141.4 37.4091 142.688 37.7008 143.801 38.2841C144.922 38.8598 145.797 39.6477 146.426 40.6477C147.055 41.6402 147.369 42.7614 147.369 44.0114C147.369 44.875 147.206 45.7197 146.881 46.5455C146.563 47.3712 146.006 48.2917 145.21 49.3068C144.415 50.3144 143.309 51.5379 141.892 52.9773L137.267 57.8182V57.9886H147.744V61H132.426Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 16,
    width: 80,
    height: 66,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5057 37.7273V61H55.983V41.25H55.8466L50.2784 44.8864V41.5227L56.0852 37.7273H59.5057Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_121"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 16,
    width: 80,
    height: 66,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateTwo);
export default __webpack_public_path__ + "static/media/template_two.6433d424ac3c475d46c65f78d19b62f2.svg";
export { ForwardRef as ReactComponent };